export const amountUnitsOptions = [
  {
    label: '$',
    value: 'dollars',
  },
  {
    label: '%',
    value: 'percent',
  },
];

export const minimumUnitsOptions = [
  {
    label: 'No Minimum',
    value: '',
  },
  {
    label: '$',
    value: 'dollars',
  },
  {
    label: 'Copies',
    value: 'copies',
  },
];

export const durationOptions = [
  {
    label: 'Once',
    value: 'once',
  },
  {
    label: 'Forever',
    value: 'forever',
  },
];

export const submitButtonTextOptions = {
  edit: 'Edit Discount',
  create: 'Create Discount',
};
